import Button from "@components/Button";
import { Row } from "@components/Layout";
import { playerContext } from "@layouts/App/context/Player";
import { AiOutlineBackward, AiOutlineForward } from "solid-icons/ai";
import { FaSolidPause, FaSolidPlay } from "solid-icons/fa";
import { Show, useContext } from "solid-js";
import { PlayerControlButton, PlayerControlPlayButtonWrapper, PlayerControlsWrapper } from "./styled";

const TrackControls = () => {
	const { player, canGoPrevious, canGoNext, handleTogglePlayer, setPlayer } = useContext(playerContext);

	return (
		<Row justifyContent="center" padding="20px 0">
			<PlayerControlsWrapper h="40px" w="180px">
				<PlayerControlButton disabled={!canGoPrevious()} onclick={() => setPlayer("track", (s) => s - 1)}>
					<AiOutlineBackward font-size="22px" />
				</PlayerControlButton>
				<PlayerControlPlayButtonWrapper>
					<Button diameter="70px" disabled={!player.queue[player.track]} onclick={() => handleTogglePlayer(true)}>
						<Show when={player.playing} fallback={<FaSolidPlay font-size="30px" style={{ "margin-left": "4px" }} />}>
							<FaSolidPause font-size="30px" />
						</Show>
					</Button>
				</PlayerControlPlayButtonWrapper>
				<PlayerControlButton disabled={!canGoNext()} onclick={() => setPlayer("track", (s) => s + 1)}>
					<AiOutlineForward font-size="22px" />
				</PlayerControlButton>
			</PlayerControlsWrapper>
		</Row>
	);
};
export default TrackControls;
